@if (categoryData) {

  <div class="pb-5">
    <form #productForm="ngForm" (ngSubmit)="saveCategory()">

      <!-- Title -->
      <app-cards-basic title="{{ 'COMMON.title' | translate }}">
        @for(lang of _languageService.supportedLangs; track lang){
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>{{ 'COMMON.title_' + lang | translate }}</mat-label>
            <input matInput
                   required
                   [(ngModel)]="categoryData.translations[lang].name"
                   name="productTitle_{{ lang }}">
          </mat-form-field>
        }
      </app-cards-basic>

      <!-- Permalink -->
      <app-cards-basic title="Permalink">
        @for(lang of _languageService.supportedLangs; track lang){
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Permalink ({{ 'COMMON.' + lang | translate }})</mat-label>
            <input matInput
                   required
                   [(ngModel)]="categoryData.translations[lang].slug"
                   name="slug_{{ lang }}"
                   [appSlugTransform]="categoryData.translations[lang].name">
          </mat-form-field>
        }
      </app-cards-basic>
    </form>

    <!-- Actions -->
    <button mat-button
            color="primary"
            type="button"
            (click)="cancel()"
            class="bp-button">
      {{ 'ACTIONS.cancel' | translate }}
    </button>
    <button mat-flat-button
            color="primary"
            [disabled]="!productForm.valid"
            (click)="saveCategory()"
            class="bp-button">
      {{ 'ACTIONS.save' | translate }}
    </button>
  </div>
}
